var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height justify-center",class:_vm.containerClasses,attrs:{"fluid":""}},[(_vm.recoveryCode)?_c('SetNewPassword',{attrs:{"recoveryCode":_vm.recoveryCode}}):_vm._e(),(!_vm.recoveryCode)?_c('RecoveryRequestForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }